export default from './AccountingIFCA';



// WEBPACK FOOTER //
// ./src/containers/AccountingIFCA/index.js